<template>
  <v-card :loading="loading">
    <v-card-title>
      Ανοιχτές βλάβες
      <v-icon v-tooltip="'Αν κάποια '+$unitText('ανυψωτικά')+'παρουσιάζουυν κάποια βλάβη, μπορείτε να ενημερώσετε' +
                             'το γραφείο. Αυτόματα ο πρώτος διαθέσιμος τεχνικός θα λάβει την αντίστοιχη ειδοποίηση.'">
        mdi-help-circle-outline
      </v-icon>
    </v-card-title>
    <v-card-text class="pb-0" v-if="userDetails.Allows.AddCallouts && !hideButtons">
      Αναφέρετε βλάβη για κάποιο <wnl-text>ανυψωτικό</wnl-text> σας.
    </v-card-text>
    <v-list class="pt-0">
      <event-mobile-item list-type="dense" @click="$router.push('/event/'+e.Event_ID)" show-status show-last-update hide-insert-date
                         hide-type v-for="e in ongoingCallouts" :item="e"/>
    </v-list>
    <v-card-text v-if="userDetails.Allows.AddCallouts && !hideButtons">
      <v-btn color="callout" to="/addCallout" dark> ΝΕΑ ΒΛΑΒΗ</v-btn>
      <v-btn text color="primary" to="/history"> ΟΛΕΣ</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import EventItem from "./EventItem";
import EventMobileItem from "./EventMobileItem";
import WnlText from "@/wl-unit-text/WnlText";

export default {
  name: "OpenCallouts",
  components: {WnlText, EventMobileItem, EventItem},
  props: {
    loading: Boolean, maxHeight: {type: String, default: null, required: false},
    hideButtons: {type: Boolean, default: false, required: false}
  },
  computed: {
    ...mapGetters([
      'userDetails',
      "ongoingCallouts"
    ])
  }
}
</script>

<style scoped>

</style>
